import { useCallback, useState } from 'react';
import { Button } from '@mui/material';
import { FilterAltOff as FilterAltOffIcon } from '@mui/icons-material';
import type { GridApi } from 'ag-grid-community';

export function hasActiveColumnFilters(api: GridApi | null | undefined): boolean {
  if (!api || api.isDestroyed()) return false;
  const model = api.getFilterModel();
  return model != null && Object.keys(model).length > 0;
}

export function useColumnFiltersActive() {
  const [columnFiltersActive, setColumnFiltersActive] = useState(false);

  const syncColumnFilters = useCallback((api: GridApi | null | undefined) => {
    setColumnFiltersActive(hasActiveColumnFilters(api));
  }, []);

  const clearColumnFilters = useCallback((api: GridApi | null | undefined) => {
    if (api && !api.isDestroyed()) {
      api.setFilterModel(null);
    }
    setColumnFiltersActive(false);
  }, []);

  return { columnFiltersActive, syncColumnFilters, clearColumnFilters };
}

export function ClearGridFiltersButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<FilterAltOffIcon />}
      onClick={onClick}
    >
      Remove all filters
    </Button>
  );
}
